import {
  GET_TRANSACTIONS,
  GET_TRANSACTIONS_SUCCESS,
  GET_TRANSACTIONS_FAILED,
  LOGOUT_ADMIN,
} from "../actions";

const INIT_STATE = {
  transactions: [],
  loading: false,
  error: null,
};

export default (state = INIT_STATE, action) => {
  let payload = action.payload;
  switch (action.type) {
    case GET_TRANSACTIONS:
      return { ...state, loading: true, error: null };
    case GET_TRANSACTIONS_SUCCESS:
      return { ...state, loading: false, error: null, transactions: payload };
    case GET_TRANSACTIONS_FAILED:
      return {
        ...state,
        loading: false,
        error: payload.error_message,
      };

    case LOGOUT_ADMIN:
      return INIT_STATE;
    default:
      return state;
  }
};
